export enum ContractTypeStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const ContractTypeStatusOptions = [
  {
    label: "Active",
    value: ContractTypeStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: ContractTypeStatus.INACTIVE,
  },
];
